<!-- eslint-disable vue/no-mutating-props -->
<template>
    <div id="comment-edit">
        <div id="comment_edit_popup" class="popup_layer" :class="{ active: this.attrs !== null }" v-if="this.attrs !== null" :key="this.componentKey">
        <div class="popup_box">
            <div class="head">
                <div class="title">
                    댓글 수정
                </div>
            </div>
            <div class="cont">
                <div class="inp">
                    <div class="img" v-if='attrs && attrs.images.length'>
                        <ul>
                            <li v-for="(image, i) in attrs.images" v-bind:key="i">
                                <div>
                                    <img :src="image.url" />
                                    <a class="btn_remove" @click="attrs.images.splice(i, 1)"></a>
                                </div>
                            </li>
                        </ul>
                    </div>

                    <form class="box" action='/v1/class-comments.php' method="PATCH" @submit="submit">
                        <input type='hidden' name='id' :value='attrs.id'>
                        <input type='hidden' name='attachment_ids[]' :value='image.bf_id'
                            v-for='(image, i) in attrs.images' v-bind:key="i">

                            <div class="img" v-if='attr && attr.images && attr.images.length'>
                                            <ul>
                                                <li v-for='(image, i) in attr.images' v-bind:key="i">
                                                    <div>
                                                        <input type='hidden' name='attachment_ids[]' :value='image.bf_id' />
                                                        <img :src='image.url' />
                                                        <a class="btn_remove" v-on:click='comment.images.splice(i, 1)'></a>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>

                        <label class="inp_file">
                            <input type="file" accept="image/*" @change="handleImageUpload">
                            <i class="icon"></i>
                            <p class="skip">파일 첨부</p>
                        </label>

                        <textarea class="inp_text" rows="1" onkeydown="resize(this)" onkeyup="resize(this)"
                            name='data[message]' v-model='attrs.message' placeholder="댓글을 입력해주세요." required
                            autofocus></textarea>
                        <button type="submit" class="inp_submit"><i class="icon"></i>
                            <p class="skip">댓글달기</p>
                        </button>
                    </form>
                </div>
            </div>
        </div>
        <div class="popup_close btnCloseWhite" @click="clear">
            <i class="icon"></i>
        </div>
    </div>
</div>
</template>

<script>
    import axios from 'axios';
    import _ from 'lodash';

    export default {
        name: 'CommentEdit',
        props: {
        },
        data() {
            return {
                componentKey: 0,
                attrs: null,
            };
        },
        setup() {
        },
        methods: {
            // force re-render
            forceRerender() {
                this.componentKey += 1;  
            },
            setAttrs(attribute) {
                this.attrs = _.merge({}, attribute);
                this.forceRerender()
            },
            handleImageUpload(e) {
                const files = e.target.files;
                const formData = new FormData();
                formData.append('file', files[0]);
                formData.append("disk", "_class_comments");

                axios.post('/v1/attachments.php', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }).then((response) => {
                    const { url, bf_id } = response.data.data

                    // eslint-disable-next-line vue/no-mutating-props
                    this.attrs.images = this.attrs.images.push({
                        url: url,
                        bf_id: bf_id
                    });
                });
            },
            clear() {
                // eslint-disable-next-line vue/no-mutating-props
                this.attrs = null
                document.querySelector('#bg').classList.remove('active')
            },
            onImageUploaded(response) {
                const { url, bf_id } = response.data.data;

                // eslint-disable-next-line vue/no-mutating-props
                this.attrs.images.splice(this.attrs.images.length, 0, {
                    url: url,
                    bf_id: bf_id
                })
            },
            submit(e) {
                e.preventDefault();

                const form = e.target;
                const formData = new FormData(form);

                axios.post(form.action, formData, {
                    headers: {
                        'X-HTTP-Method-Override': 'PATCH',
                    },
                }).then(() => {
                    // eslint-disable-next-line vue/no-mutating-props
                    this.attrs = null;
                    this.$emit('commentUpdated');
                });
            },
        },
    };
</script>